<template>
    <el-dialog title="新增版本" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
        <el-form :model="form">
            <el-form-item label="平台" :label-width="formLabelWidth">
                <el-select v-model="form.platform" placeholder="请选择平台">
                    <el-option label="Android" value="0"></el-option>
                    <el-option label="IOS" value="1"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="版本号" :label-width="formLabelWidth">
                <el-input v-model="form.version" autocomplete="off" placeholder="请输入版本号"></el-input>
            </el-form-item>
            <el-form-item label="更新地址" :label-width="formLabelWidth">
                <el-input v-model="form.updateUrl" autocomplete="off" placeholder="请输入更新地址"></el-input>
            </el-form-item>
            <el-form-item label="更新备注" :label-width="formLabelWidth">
                <el-input v-model="form.updateNotes" autocomplete="off" placeholder="请输入更新备注"></el-input>
            </el-form-item>
            <el-form-item label="是否强制更新" :label-width="formLabelWidth">
                <el-radio v-model="form.isMandatory" label="0">否</el-radio>
                <el-radio v-model="form.isMandatory" label="1">是</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="addVersions">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import versionsApi from '@/api/setting/versions.js';
export default {
    props: ['message'],
    data() {
        return {
            dialogFormVisible: false,
            form: {
                platform: '', // 平台
                version: '', // 版本号
                updateUrl: '', // 更新地址
                updateNotes: '', // 更新备注
                isMandatory: '', // 是否强制更新
            },
            formLabelWidth: '120px'
        }
    },
    methods: {
        // 关闭组件
        handleCancel() {
            this.dialogFormVisible = false // 关闭弹窗
            this.$emit('closeFunction', this.dialogFormVisible) // 传递数据给父组件
        },
        // 确定（新增）
        addVersions() {
            // console.log(this.form);
            // 判断每一项都填了才能继续执行
            if (!this.form.platform.trim() || !this.form.version.trim() || !this.form.updateUrl.trim() || !this.form.updateNotes.trim() || !this.form.isMandatory.trim()) {
                this.$message({
                    message: '请填写完整信息',
                    type: 'warning'
                });
                return;
            }
            const platform = this.form.platform;
            const version = this.form.version;
            const updateUrl = this.form.updateUrl;
            const updateNotes = this.form.updateNotes;
            const isMandatory = this.form.isMandatory;
            // 新增 请求
            versionsApi.getAddVersions({ platform: platform, version: version, updateUrl: updateUrl, updateNotes: updateNotes, isMandatory: isMandatory }).then(response => {
                // console.log(response.data);
                this.$message({
                    message: '新增成功',
                    type: 'success'
                });
                this.$emit('add-success');
            }).catch(error => {
                console.error(error);
            });
            // 清空表单数据
            this.form.platform = '';
            this.form.version = '';
            this.form.updateUrl = '';
            this.form.updateNotes = '';
            this.form.isMandatory = '';
            this.dialogFormVisible = false
            this.$emit('closeFunction', this.dialogFormVisible) // 传递数据给父组件
        }
    },
    watch: {
        message(newVal) {
            this.dialogFormVisible = newVal // 监视 props 的变化，将值赋给子组件的 data 属性
        }
    },
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/setting/versions/components/AddView.vue